import { auth } from "../firebase";

export const fetchResetCodeDetails = async (code) => {
  try {
    if (code) {
      await auth.verifyPasswordResetCode(code);
      return { error: null, payload: "success" };
    } else {
      throw new Error("error");
    }
  } catch (e) {
    if (e && e.message) {
      throw new Error(e.message);
    } else {
      throw new Error(e);
    }
  }
};
